<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="preloader-backdrop">
  <div class="page-preloader" i18n="@@loading">Loading</div>
</div>

<router-outlet></router-outlet>

<div class="sidenav-backdrop backdrop"></div>

<div class="to-top"><em class="fa fa-angle-double-up"></em></div>
